import { render, staticRenderFns } from "./MemberReviews.vue?vue&type=template&id=6374c460&scoped=true&"
import script from "./MemberReviews.vue?vue&type=script&lang=js&"
export * from "./MemberReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6374c460",
  null
  
)

export default component.exports